import { FILTER_TYPE } from './constants';

export const buildQuery = (filters = [], orderCriteria) => {

    if(!Array.isArray(filters)) {

        return '';

    }

    let query = filters.reduce((accumulator, clause, index, arr) => {

        const values = (clause.type === FILTER_TYPE.range) ? clause.values[0].value : JSON.stringify(clause.values.map(a => a.value));
        const fieldName = clause.name;
        const operator = clause.comparator;
        const logicalConjunctionOperator = index < (arr.length - 1) ? clause.logicalConjunctionOperator || 'AND' : '';

        return `${accumulator} ${fieldName} ${operator} ${values} ${logicalConjunctionOperator}`.trim();

    }, '');

    if (query && orderCriteria) {

        query = `${query} Order By ${orderCriteria}`;

    }

    return query;

};
